function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.1,77.7h113.5V19.3c0-3.1-2.6-5.7-5.4-5.7H12.8c-3.1,0-5.7,2.6-5.7,5.7V77.7z M120.6,84.8H7.1v6.6c0,3.1,2.6,5.7,5.7,5.7 h102.3c2.9,0,5.4-2.6,5.4-5.7V84.8z M12.8,6.4h102.3c6.8,0,12.8,5.7,12.8,12.8v72.1c0,7.1-6,12.8-12.8,12.8H79.8v10h10.5 c2,0,3.4,1.7,3.4,3.7s-1.4,3.4-3.4,3.4H37.6c-2,0-3.4-1.4-3.4-3.4s1.4-3.7,3.4-3.7h10.5v-10H12.8C5.7,104.2,0,98.5,0,91.4V19.3 C0,12.1,5.7,6.4,12.8,6.4z M72.7,104.2H55.3v10h17.4V104.2z"
}));

function SvgVirtual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default SvgVirtual;